var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 16.9999H15.5M3.5 14.5999V12.1301C3.5 10.9814 3.5 10.407 3.64805 9.87807C3.7792 9.40953 3.99473 8.96886 4.28405 8.57768C4.61067 8.13608 5.06404 7.78346 5.97078 7.07822L8.57078 5.056C9.97608 3.96298 10.6787 3.41648 11.4546 3.2064C12.1392 3.02104 12.8608 3.02104 13.5454 3.2064C14.3213 3.41648 15.0239 3.96299 16.4292 5.056L19.0292 7.07822C19.936 7.78346 20.3893 8.13608 20.7159 8.57768C21.0053 8.96886 21.2208 9.40953 21.3519 9.87807C21.5 10.407 21.5 10.9814 21.5 12.1301V14.5999C21.5 16.8401 21.5 17.9603 21.064 18.8159C20.6805 19.5685 20.0686 20.1805 19.316 20.564C18.4603 20.9999 17.3402 20.9999 15.1 20.9999H9.9C7.65979 20.9999 6.53969 20.9999 5.68404 20.564C4.93139 20.1805 4.31947 19.5685 3.93597 18.8159C3.5 17.9603 3.5 16.8401 3.5 14.5999Z",
    stroke: "#939393",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17H15.5",
    stroke: "#939393",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileHome);
export default __webpack_public_path__ + "static/media/mobile-home.ded03f86fc3e7a5d52a74b8c5b1467a2.svg";
export { ForwardRef as ReactComponent };